/* HC okt 2026: quick view / Choose options op een productkaart opent op dezelfde variant als de kaartlink
   (type-chip Driver/Fairway/Hybrid of het gekozen kleurbolletje). Geladen via snippets/hc-copy-fixes.liquid. */
(function () {
  document.addEventListener('click', function (e) {
    var q = e.target.closest && e.target.closest('product-card quick-view');
    if (!q) return;
    var card = q.closest('product-card');
    var a = card && card.querySelector('a.product-card-title');
    var m = a && (a.getAttribute('href') || '').match(/[?&]variant=(\d+)/);
    if (!m) return;
    var vid = m[1];
    var old = document.querySelector('#Product-Drawer-Content variant-selects');
    var tries = 0;
    (function wait() {
      var vs = document.querySelector('#Product-Drawer-Content variant-selects');
      if (!vs || vs === old) {
        if (++tries < 60) setTimeout(wait, 100);
        return;
      }
      var js = vs.querySelector('script[type="application/json"]');
      var data;
      try { data = JSON.parse(js.textContent); } catch (err) { return; }
      var v = data.filter(function (x) { return String(x.id) === vid; })[0];
      if (!v) return;
      var radios = [].slice.call(vs.querySelectorAll('input[type=radio]'));
      var names = [];
      radios.forEach(function (r) { if (names.indexOf(r.name) < 0) names.push(r.name); });
      v.options.forEach(function (o, i) {
        var r = radios.filter(function (x) { return x.name === names[i] && x.value === o; })[0];
        if (r && !r.checked) {
          r.checked = true;
          r.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    })();
  }, true);
})();
